import { FaAward } from "react-icons/fa";
// import { FiUsers } from "react-icons/fi";
import { VscFolderLibrary } from "react-icons/vsc";

export const aboutCards = [
  { icon: FaAward, title: "Experience", description: "4+ Years Working" },
  // { icon: FiUsers, title: "Clients", description: "200+ Worldwide" },
  { icon: VscFolderLibrary, title: "Projects", description: "+10 Completed" },
];

export const aboutText = [
  "I’m a Front-end Developer with over 4 years of experience building scalable web and mobile applications using React, Next.js, and React Native. I’ve led the development of production-ready platforms used by thousands of users, focusing on performance, clean architecture, and user-centered design. Meta Front-end Developer Certified, I enjoy turning complex requirements into intuitive, reliable, and maintainable digital experiences.",
];
